import { APP_ROUTES } from '@/constants/pages';
import { _t } from '@/locale/i18n';
import { Identifier, Link, LinkGroup } from './Footer.types';

export const baseTranslationKey = 'features.footer' as const;

export const FOOTER_LINKS: { [key in LinkGroup]: Link[] } = {
  account: [
    {
      label: _t(`${baseTranslationKey}.link.${Identifier.Login}`),
      identifier: Identifier.Login,
    },
    {
      label: _t(`${baseTranslationKey}.link.${Identifier.Bookings}`),
      identifier: Identifier.Bookings,
      to: APP_ROUTES.MY_BOOKINGS,
    },
    {
      label: _t(`${baseTranslationKey}.link.${Identifier.Favorites}`),
      identifier: Identifier.Favorites,
      to: APP_ROUTES.MY_FAVORITES,
    },
    {
      label: _t(`${baseTranslationKey}.link.${Identifier.Giftcard}`),
      identifier: Identifier.Giftcard,
      to: APP_ROUTES.GIFTCARD_USE,
    },
    {
      label: _t(`${baseTranslationKey}.link.${Identifier.Wellnesscard}`),
      identifier: Identifier.Wellnesscard,
      to: APP_ROUTES.GIFTCARD_USE,
    },
    {
      label: _t(`${baseTranslationKey}.link.${Identifier.Cancel_by_code}`),
      identifier: Identifier.Cancel_by_code,
      to: APP_ROUTES.CANCEL_BY_CODE,
    },
  ],
  bokadirekt: [
    {
      label: _t(`${baseTranslationKey}.link.${Identifier.About}`),
      identifier: Identifier.About,
      to: APP_ROUTES.ABOUT,
    },
    {
      label: _t(`${baseTranslationKey}.link.${Identifier.Blog}`),
      identifier: Identifier.Blog,
      to: APP_ROUTES.BLOG,
    },
    {
      label: _t(`${baseTranslationKey}.link.${Identifier.Faq}`),
      identifier: Identifier.Faq,
      to: APP_ROUTES.FAQ,
    },
    {
      label: _t(`${baseTranslationKey}.link.${Identifier.Advice}`),
      identifier: Identifier.Advice,
      to: APP_ROUTES.ADVICE_PAGES_ARCHIVE,
    },
    {
      label: _t(`${baseTranslationKey}.link.${Identifier.Career}`),
      identifier: Identifier.Career,
      to: 'https://careers.bokadirekt.se/',
      external: true,
    },
    {
      label: _t(`${baseTranslationKey}.link.${Identifier.Support}`),
      identifier: Identifier.Support,
      to: APP_ROUTES.SUPPORT,
    },
  ],
  legal: [
    {
      label: _t(`${baseTranslationKey}.link.${Identifier.Ethical_policy}`),
      identifier: Identifier.Ethical_policy,
      to: APP_ROUTES.ETHICAL_POLICY,
    },
    {
      label: _t(`${baseTranslationKey}.link.${Identifier.Privacy_policy}`),
      identifier: Identifier.Privacy_policy,
      to: APP_ROUTES.PRIVACY_POLICY,
    },

    {
      label: _t(`${baseTranslationKey}.link.${Identifier.Cookie_policy}`),
      identifier: Identifier.Cookie_policy,
      to: APP_ROUTES.COOKIE_POLICY,
    },
    {
      label: _t(`${baseTranslationKey}.link.${Identifier.Terms}`),
      identifier: Identifier.Terms,
      to: APP_ROUTES.TERMS,
    },
  ],
};
